export const BASE_PATH = import.meta.env.BASE_URL;
